
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#0177FD","width":"100%","height":"100%"}}),_c('path',{attrs:{"d":"M353.191 206.856L256.513 371.17l-99.105-56.149 49.039-83.338 51.47 29.15 95.274-53.977zm-40.985 84.738L356 316.398l-87.596 49.628 43.802-74.432zM156 203.093l43.794 24.828L156 302.349v-99.256zM257.916 141l98.082 55.566-98.082 55.567-97.52-55.244-.558-.323L257.916 141z","fill":"#FFF"}})])])
          )
        }
      }
    